module.exports = __webpack_public_path__ + "img/IT.1ae21ce4.svg";